import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** MANAGE GROUPS API CONFIG                                         ***!
  \*******************************************************************************/

export const apiConfig = {
  FieldConfiguration: BOM.baseUrl("fieldconfiguration"),
  GlimAccounts: BOM.baseUrl("glimaccounts"),
  GsimAccounts: BOM.baseUrl("gsimaccounts"),
  Search: BOM.baseUrl("search"),
  Groups: BOM.baseUrl("groups"),
  SavingsAccounts: BOM.baseUrl("savingsaccounts"),
  Savings: BOM.baseUrl("savings"),
  Charges: BOM.baseUrl("charges"),
  Clients: BOM.baseUrl("clients"),
  Loans: BOM.baseUrl("loans"),
  GlAccounts: BOM.baseUrl("glaccounts"),
  Offices: BOM.baseUrl("offices"),
  JournalEntries: BOM.baseUrl("journalentries"),
  RescheduleLoans: BOM.baseUrl("rescheduleloans"),
  Batches: BOM.baseUrl("batches"),
  StandingInstructions: BOM.baseUrl("standinginstructions"),
  Codes: BOM.baseUrl("codes"),
  Accounttransfers: BOM.baseUrl("accounttransfers"),
};
//
/*!*******************************************************************************!
  !*** GROUP LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  manageGroup: "Manage Group",
  newGroup: "New Group",
  groupSavingsDetail: "Group Savings Detail",
  office: "Branch",
  totalPrincipalDue: "Total Principal Due",
  totalFees: "Total Fees",
  totalOutstanding: "Total Outstanding",
  totalPenalties: "Total Penalties",
  totalInterest: "Total Interest",
  name: "Name",
  relationshipManager: "Relationship Manager",
  active: "Active",
  submittedDate: "Submitted Date",
  externalID: "External ID",
  activationOn: "Activation On",
  add: "Add",
  type: "Type",
  collectedOn: "Collected On",
  amount: "Amount",
  date: "Date",
  repaymentsEvery: "Repayments Every",
  noDuplicateCharges: "No Duplicate Charges",
  editGroup: "Edit Group",
  generalInfo: "General Information",
  refresh: "Refresh",
  groupId: "Group ID",
  mobilePhone: "Mobile Phone",
  branch: "Branch",
  status: "Status",
  product: "Product",
  productInfo: "Product Information",
  details: "Details",
  terms: "Terms",
  charges: "Charges",
  preview: "Preview",
  accountOfficer: "Account Officer",
  newSavingApplication: "New Savings Application",
  currency: "Currency",
  currencyInfo: "Currency Information",
  decimalPlaces: "Decimal Places",
  nominalAnnualInterest: "Nominal Annual Interest",
  interestCompoundingPeriod: "Interest Compounding Period",
  currencyInMultiplesOf: "Currency In Multiples Of",
  interestPostingPeriod: "Interest Posting Period",
  interestCalculatedUsing: "Interest Calculated Using",
  daysInYear: "Days In Year",
  minimumOpeningBalance: "Minimum Opening Balance",
  lockInPeriod: "Lock-In Period",
  lockInPeriodType: "Lock-In Period Type",
  applyWithdrawalFeeForTransfers: "Apply Withdrawal Fee For Transfers",
  isOverdraftAllowed: "Is Overdraft Allowed",
  isLienAllowed: "Is Lien Allowed",
  enforceMinimumBalance: "Enforce Minimum Balance",
  minimumBalance: "Minimum Balance",
  maxLienAmtLimit: "Maximum Lien Amount Limit",
  maxOverdraftAmtLimit: "Maximum Overdraft Amount Limit",
  nominalAnnualIntrstForOverdraft: "Nominal Annual Interest For Overdraft",
  minOverdraftForIntrstCalc: "Min Overdraft Required For Interest Calculation",
  interestInfo: "Interest Information",
  chargeInfo: "Charge Information",
  addCharge: "Add Charge",
  currentBalance: "Current Balance",
  availableBalance: "Available Balance",
  accountInfo: "Account Information",
  bban: "Bban",
  depositIban: "Deposit Iban",
  nominalInterestRate: "Nominal Interest Rate",
  performanceHistory: "Performance History",
  interestEarned: "Interest Earned",
  totalDeposits: "Total Deposits",
  financialInfo: "Financial Information",
  totalAnnualFees: "totalAnnualFees",
  lienBlockedAmount: "Lien (Blocked Amount)",
  earnedIntrstNotPosted: "Earned Interest Not Posted",
  lastActiveTransactionDate: "Last Active Transaction Date",
  annualFee: "Annual Fee",
  viewJournalEntries: "View Journal Entries",
  TransactionSuccessfullyReversed: "Transaction was successfully reversed",
  journalEntries: "Journal Entries",
  searchParams: "Search Parameter",
  chargeType: "Charge Type",
  paymentDueAt: "Payment due at",
  paymentDueAsOf: "Payment due as of",
  calculationType: "Calculation Type",
  due: "due",
  paid: "Paid",
  waived: "Waived",
  outstanding: "Outstanding",
  paymentDate: "Payment Date",
  approveSavingsGrpApp: "Approve Saving Account",
  undoApprovalSavingsGrp: "Undo Approval Saving Account",
  undoApprovalSavingsGrpMsg:
    "Savings Group Application was successfully disapproved",
  deleteSavingsGrpMsg: "Savings Group was successfully deleted",
  chargeCalculation: "Charge calculation",
  chargeTimeType: "Charge time type",
  addChargesSavingsGrp: "Add Savings Charges",
  rejectSavingsGrp: "Reject Savings Account",
  rejectSavingsGrpMsg: "Savings Group was successfully rejected",
  rejectedOnDate: "Rejected On",
  withdrawnByAppSavingsGrpMsg:
    "Savings Group was successfully withdrawn by Applicant",
  withdrawwSavingsGrp: "Withdraw Saving Account",
  assignSavingsGrpOfficer: "Assign Savings Officer",
  unassignSavingsGrpOfficer: "Unassign Savings Officer",
  toSavingsOfficer: "To Savings Officer",
  assignmentDate: "Assignment Date",
  lockInPeriodType: "Lock-In Period Type",
  unassignedOn: "Unassigned On",
  account: "Account",
  dateRange: "Date Range",
  filter: "Filter",
  transactionId: "Transaction Unique ID",
  activate: "Activate",
  activateSavingsGrp: "Activate Savings Account",
  grpSavingsAccountSetup: "Group Savings Setup",
  dueForCollectionOn: "Due for Collection On",
  attendance: "Attendance",
  repeat: "Repeat",
  repeats: "Repeats",
  repeatsEvery: "Repeats Every",
  attachMeeting: "Attach Meeting",
  repeatingDays: "Repeating Days",

  // DETAIL GROUP
  detailGroup: "Group Detail",
  accountInformation: "Account Information",
  meetings: "Meeting Schedule",
  activationDate: "Activation Date",
  center: "Center",
  activeClients: "Active Customers",
  activeGroupLoans: "Active Group Loans",
  activeClientLoans: "Active Customer Loan",
  ActiveGroupBorrowers: "Active Group Borrowers",
  activeClientBorrowers: "Active Customer Borrowers",
  nextMeetingOn: "Next Meeting On",
  meetingFrequency: "Meeting Frequency",
  savingsAccounts: "Savings Accounts",
  savingsAccount: "Savings Account",
  GLIMLoansAccount: "Group Loan (Individual Monitoring) Account",
  GLIMLoansAccounts: "Group Loan (Individual Monitoring) Accounts",
  loansAccount: "Loans Account",
  loansAccounts: "Loans Accounts",
  GSIMAccounts: "Group Savings (Individual Monitoring) Accounts",
  GSIMAccount: "Group Savings (Individual Monitoring) Account",
  activeOverdueGroupLoans: "Active Overdue Group Loans",
  activeOverdueClientLoans: "Active Overdue Customer Loans",
  newNoteMsg: "New Note is successfully added",
  createdBy: "Created By",
  createdOn: "Created On",
  note: "Note",
  notes: "Notes",
  resourceId: "Resource ID",
  client: "Customer",
  role: "Role",
  newRoleMsg: "Role is successfully assigned",
  unassignRoleMsg: "Role is successfully unassigned",
  transferClients: "Transfer Customer Between Groups",
  clients: "Customers",
  availableClients: "Available Customers",
  selectedClients: "Selected Customers",
  inheritGroupLoanOfficer: "Inherit Group Loan Officer",
  option: "Option",
  addGroup: "Add Group",
  selectGroup: "Select Group",
  groupList: "Group List",
  group: "Group",
  groupInfo: " Group Information",
  searchGroup: "Search Group",
  transferCustomerMsg: "Customer Transferred Successfully",
  newCustomer: "New Customer",
  customerSetup: "Customer Information Setup",
  generalInfo: "General Information",
  customerType: "Customer Type",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  dateOfBirth: "Date Of Birth",
  gender: "Gender",
  contactInfo: "Contact Information",
  email: "Email",
  mobileNumber: "Mobile Number",
  nationality: "Nationality",
  identifactionType: "Identifaction Type",
  identifactionNo: "Identifaction No",
  issuingDate: "Issuing Date",
  expiryDate: "Expiry Date",
  incorporationDate: "Incorporation Date",
  incorporationValidUntil: "Incorporation Valid Until",
  incorporationNumber: "Incorporation Number",
  constitution: "Constitution",
  mainBusinessLine: "Main Business Line",
  remarks: "Remarks",
  additionalInfo: "Additional Info",
  isStaff: "Is Staff",
  relationshipManager: "Relationship Manager",
  customerClassification: "Customer Classification",
  openCasaAccount: "Open CASA Account?",
  selectCasaProduct: "Select CASA Product",
  submittedOn: "Submitted On",
  submittedDate: "Submitted Date",
  addressInfo: "Address Information",
  addressTypeId: "Address Type",
  addressOne: "Address One",
  addressTwo: "Address Two",
  city: "City",
  country: "Country",
  stateProvince: "State/Province",
  postalCode: "Postal Code",
  addressStatus: "Address Status",
  newCustomerMsg: "New Customer Created Successfully",
  associateNewMembers: "Associate New Members",
  addMember: "Add Member",
  clientId: "Customer ID",
  selectedMembers: "Selected Members",
  selectedMember: "Selected Member",
  manageCustomerMsg: "Group Member Added Successfully",
  removeMemberMsg: "Member Removed",

  name: "Name",
  staff: "Staff",
  submittedOn: "Submitted on",
  groupSetup: "Group Setup",
  additionalInfo: "Additional Information",
  customerInfo: "Customer Information",
  work: "Work",
  isActive: "is Active ?",
  glimLoanAccountOverview: "GLIM Loan Account Overview",
  detailGlimLoanAccount: "Detail GLIM Loan Account",

  //SUCCESS MESSAGES
  editGroupMsg: "Group was succesfully updated",
  newGroupSavingAppMsg: "Group Savings was successfully created",
  newGroupMsg: "Group was succesfully Created",
  updateGroupMsg: "Customer Group was updated",
  postIntrstSavingsGrpMsg: "Savings Group Interest was successfully posted",
  calculateIntrstSavingsGrpMsg:
    "Savings Group Interest was successfully calculated",
  waivedChargeMsg: "Waive Charge was successful",
  AccountSuccefullyApproved:
    "Savings Group Application was successfully approved",
  addChargesSavingsGrpMsg: "Savings Group Charge was successfully added",
  assignSavingsGrpOfficerMsg: "Savings Group Officer was successfully assigned",
  unassignSavingsGrpOfficerMsg:
    "Savings Group Officer was successfully unassigned",
  modifySavingsGrpAppMsg:
    "Savings Group Application was successfully modififed",
  assignGroupOfficerMsg: "Customer Group Staff was succesfully assigned",
  unssignGroupOfficerMsg: "Customer Group Staff was succesfully Unassigned",
  activateSavingsGrpMsg: "Group Savings Account was successfully activated",
  grpAttendanceMsg: "Group Attendance was successfully captured",
  newGLIMLoanAppMsg: "GLIM Loan Account was successfully created",

  //END OF SUCCESS MESSAGES

  selectCustomer: "Select Customer",
  id: "ID",
  customerDetails: "Customer Details",
  selectedCustomer: "Selected Customer",
  selectedCustomers: "Selected Customers",
  customer: "Customer",
  customerList: "Customer List",
  activateCustomerGroup: "Activate Customer Group",

  // GROUP LOAN APPLICATION
  newLoanApplication: "New Loan Application",
  loanApplicationSetup: "Loan Application Setup",
  description: "Description",
  includeInBorrowerCycle: "Include In Customer Loan Counter",
  closeDate: "Close Date",
  startDate: "Start Date",
  fund: "Fund",
  loanOfficer: "Loan Officer",
  loanPurpose: " Loan Purpose",
  submittedOn: "Submitted On",
  disbursementOn: "Disbursement On",
  savingsLinkage: "Saving Linkage",
  linkSavings: "Link Savings",
  createStandingInstruction: "Create Standing Instruction At Disbursement",
  calculateInterest: "Calculate Interest",
  maximumAllowedOutstanding: "Maximum Allowed Outstanding",
  advancePayments: "Advance Payments",
  interestRecalculationCompounding: "Interest Recalculation Compounding",
  FrequencyForRecalculate: "Frequency For Recalculate",
  loanTerm: "Loan Term",
  loanTermFrequency: "Loan Term Frequency",
  repaidEvery: "Repaid Every",
  repaymentFrequency: "Repayment Frequency",
  on: "On",
  dayOfWeek: "Day Of Week",
  numberOfRepayments: "Number Of Repayments",
  numberOfNewRepayments: "Number of New Repayments",
  firstRepaymentOn: "First Repayment On",
  interestChargedFrom: "Interest Charged From",
  interestInformation: "Interest Information",
  nominalInterestRate: "Nominal Interest Rate",
  nominalInterestRateFrequency: "Nominal Interest Rate Frequency",
  interestMethod: "Interest Method",
  isEqualAmortization: "Is Equal Amortization",
  amortization: "Amortization",
  interestCalculationPeriod: "Interest Calculation Period",
  calculateInterest: " Calculate Interest for Exact Days In Partial Period",
  arrearsTolerance: "Arrears Tolerance",
  interestFreePeriod: "Interest Free Period",
  repaymentStrategy: "Repayment Strategy",
  moratorium: "Moratorium",
  onPrincipalPayment: "On Principal Payment",
  onInterestPayment: "On Interest Payment",
  onArrearsAging: "On Arrears Aging",
  loanTrancheDetails: "Loan Tranche Details",
  maximumAllowedOutstanding: "Maximum Allowed Outstanding",
  interestRecalculation: "Interest Recalculation",
  recalculateInterest: "Recalculate Interest",
  daysinYear: "Days In Year",
  advancePayments: "Advance Payment",
  daysInMonth: "Days in Month",
  interestRecalculationCompounding: "Interest Recalculation Compounding",
  calculateInterestForPartialPeriod:
    "Calculate interest for exact days in partial period",
  FrequencyForRecalculate: "Frequency For Recalculate",
  frequencyForCompounding: "Frequency For Compounding",
  expectedDisbursementDate: "Expected Disbursement Date",
  repaymentInfo: "Repayment Information",
  selectedCollaterals: "Selected Collaterals",
  selectedCollateral: "Selected Collateral",
  collateralInfo: "Collateral Information",
  overdueCharge: "Overdue Charge",
  overdueCharges: "Overdue Charges",
  selectedCharges: "Selected Charges",
  selectedCharge: "Selected Charge",
  collateral: " Collateral",
  value: "Value",
  description: "Description",
  charge: "Charge",
  addLoanCollateral: "Add Loan Collateral",
  newLoanApplicationMsg: "Loan Application Successful",
  assignGroupOfficer: "Assign Goup Officer",
  meetingDetails: "Meeting Details",
  startDate: "Start Date",
  repeatsOn: "Repeats On",
  syncRepayments: "Sync Repayments With Meetings",
  syncDisbursement: "Sync Disbursement Date With Meetings",
  detailLoanAccount: "Detail Loan Account",
  disbursementDate: "Disbursement Date",
  proposedAmount: "Proposed Amount",
  approvedAmount: "Approved Amount",
  disburseAmount: "Disburse Amount",
  closeGroup: "Close Group",
  closureDate: "Closure Date",
  closureReasons: "Closure reasons",
  closeCustomerGroupMsg: "Customer Group Closed Successfully",
  deleteCustomerGroupMsg: "Customer Group was successfully deleted",
  incorporationValidDate: "Incorporation Valid Date",
  clientType: "Client Type",
  installmentAmount: "Installment Amount",
  newGsimApplication: "New GSIM Application",
  accountSetup: "Account Setup",
  gsimApplicationDetail: "GSIM Application Detail",
  approveLoanAcc: "Approve Loan Account",
  approveLoanAccMsg: "Loan Account Approved Successfully",
  approvedOn: "Approved On",
  expectedDisbursementDate: "Expected Disbursement Date",
  approvedAmount: "Approved Amount",
  transactionAmount: "Transaction Amount",
  rejectLoanAcc: "Reject Loan Account",
  rejectLoanAccMsg: "Loan Account Successfully Rejected",
  rejectedOn: "Rejected On",
  undoApproval: "Undo Approve Loan Account",
  loanDisbursal: "Disburse Loan Account",
  disbursedOnDate: "Disbursed On Date",
  paymentTypes: "Payment Types",
  accountNumber: "Account Number",
  chequeNumber: "Cheque Number",
  routingCode: "Routing Code",
  receiptNumber: "Receipt Number",
  bankNumber: "Bank Number",
  loanDisbursementMsg: "Loan Account Disbursed Successfully",
  loanDisbursalToSavings: "Disburse To Savings",
  writeOffMsg: "Write Off Successful",
  writeOff: "Write Off Loan Account",
  interestWaivedOn: "Write Off On",
  intrstWaivedOn: "Interest waived on",
  interestWaivedOn: "‘Interest Waived On",
  undoDisbursalMsg: "Undo Disbursal Successful",
  undoDisbursal: "Undo Disbursal",
  closeLoanAccount: "Close Loan Account",
  closedOn: "Closed On",
  closeLoanAccountMsg: "Loan Account Closed Successfully",
  closeAsRescheduled: "Close Loan Account As Rescheduled",
  foreClosure: "Loan Foreclosure",

  interest: "Interest",
  feeAmount: "Fee Amount",
  penaltyAmount: "Penalty Amount",
  loanRepaymentMsg: "Loan Repayment Successful",
  loanRepayment: "Loan Repayment",
  transactionDate: "Transaction Date",
  waiveInterestMsg: "Waive Interest Successful",
  waiveInterest: "Waive Interest",
  addLoanChargeMsg: "Loan Charge Added Successfully",
  addLoanCharge: "Add Loan Charge",
  chargeTime: "Charge Time",
  dueOn: "Due Date",
  withdrawLoanAccountMsg: "Withdrawal Successful",
  withdrawLoanAccount: "Withdraw Loan Account",
  withdrawnOn: "Withdrawn On",
  reschedule: "Reschedule Loan",
  rescheduleFromInstallment: "Reschedule From Installment On",
  reasonForRescheduling: "Reason For Rescheduling",
  comment: "Comment",
  changeRepaymentDate: "Change Repayment Date",
  installmentRescheduledTo: "Installment Rescheduled To",
  introduceGracePeriod: "Introduce Grace Period",
  principalGracePeriods: "Principal Grace Periods",
  interestGracePeriods: "Interest Grace Periods",
  extendRepaymentPeriod: "Extend Repayment Period",
  adjustInterestRates: "Adjust Interest Rates For Remainder Of Loan",
  newInterestRates: "New Interest Rates",
  changeEMI: "Change EMI",
  EMIChange: "EMI Change",
  newEMI: "New EMI",
  changeFixedPrincipal: "Change Fixed Principal",
  newFixedPrincipal: "New Fixed Principal",
  rescheduleMsg: "Loan Reschedule Successful",
  rescheduleRequest: "Reschedule Request",
  viewRepaymentSchedule: "View Repayment Schedule",
  hideRepaymentSchedule: "Hide Repayment Schedule",
  rejectRescheduleMsg: "Loan Reschedule Rejected",
  approveRescheduleMsg: "Loan Reschedule Approved",
  modifyApplicationMsg: "Loan Application Modified Successfully",
  modifyLoanApplication: "Modify Loan Application",
  fixedPrincipal: "Fixed Principal % Per Instalment",
  assignLoanOfficerMsg: "Loan Officer Assigned Successfully",
  unassignLoanOfficerMsg: "Loan Officer Unassigned Successfully",
  assignLoanOfficer: "Assign Loan Officer",
  toLoanOfficer: "Loan Officer",
  unassignLoanOfficer: "Unassign Loan Officer",
  unassignedOn: "Unassigned On",
  deleteLoanAccount: "Delete Account",
  deleteLoanAccountMsg: "Loan Account Deleted Successfully",
  createGuarantor: "Create Guarantor",
  createGuarantorMsg: "Guarantor Created Successfully",
  relationship: "Relationship",
  viewGuarantor: "View Guarantor",
  undoApprovalMsg: "Approval Successfully Undone",
  addGuarantor: "Add Guarantor",
  selectGuarantor: "Select Guarantor",
  guarantorInfo: "Guarantor Information",
  arrearsBy: "Arrears By",
  hideDeletedGuarantors: "Hide Deleted Guarantors",
  collateralType: "Collateral Type",
  addCollateralMsg: "Collateral Added Successfully",
  loanPrepaymentMsg: "Loan Prepayment Successful",
  loanPrepayment: "Loan Prepayment",
  principal: "Principal",
  interestAmount: "Interest Amount",
  fees: "Fees",
  transactionType: "Transaction Type",
  principalpaymentdetail: "Principal Payment Detail",
  interestspayment: "Interests Payment",
  createChargeLoanTest: "Create Charge Loan Test",
  paymentDetail: "Payment Detail",
  hideAccruals: "Hide Accruals",
  maximumAllowedOutstandingBalance: "Maximum Allowed Outstanding Balance",
  installmentAmountVariations: "Installment Amount Variations",
  selectInstallment: "Select Installment",
  waiveChargeInfo: "Waive Charge Information",
  installmentNumber: "Installment Number",
  waiveChargeMsg: "Waive Charge Successful",
  editChargeMsg: "Charge was successfully edited",
  deleteChargeMsg: "Charge was successfully deleted",
  reversedChargeMsg: "Charge_Action was successfully Reversed",
  payChargeMsg: "Charge was successfully Paid",
  joinedDate: "Joined Date",
  guarantorType: "Guarantor Type",
  withdrawMoney: "Withdraw Money From Saving Account",
  bank: "Bank",
  withdraw: "withdraw",
  deposit: "Deposit",
  depositMoney: "Deposit Money to Saving Account",
  savingsAccountInfo: "Savings Account Information",
  selectChildGsimAccount: "Select GSIM Account",
  accountList: "Account List",
  balance: "Balance",
  selectedAccount: "Selected Account",
  selectedAccounts: "Selected Accounts",
  noOfNewRepayments: "Number Of new Repayments ",
  existingClient: "Existing Client",
  zip: "Zip Code",
  residence: "Residence Phone Number",
  recoverFromGurantorsMsg: "Recovery Successful",
  recoverFromGurantors: "Recover From Guarantors",
  changeLoanOfficerMsg: "Loan Officer Changed Successfully",
  changeLoanOfficer: "Change Loan Officer",
  day: "Day",
  editGuarantorMsg: "Guarantor Edited Successfully",
  deleteGuarantorMsg: "Guarantor Deleted Successfully",

  //GLIM LOAN APPLICATION

  newGLIMLoanApplication: "New GLIM Loan Application",
  glimLoanAccountSetup: "GLIM Loan Setup",
  loanTermType: "Loan Term Type",
  repaidEveryType: "Repaid Every Type",
  settings: "settings",
  settingsInfo: "Settings Information",
  loanPurpose: "Loan Purpose",
  originalLoan: "Original Loan",

  //GSIM LOAN APPLICATION

  closeGsimAccount: "Close GSIM Account",
  modifyGsimAppMsg: "GSIM Application was successfully modififed",
  gsimAccountDetail: "GSIM Account Detail",
  accountDetail: "Account Detail",
  applicationDetail: "Application  Detail",
  savingsAccountApprovedMsg: "Savings Group Account was successfully approved",
  savingsAccountUndoApprovalMsg:
    "Savings Group Account was successfully disapproved",
  rejectSavingsAccountMsg: "Savings Account was successfully rejected",
  withdrawSavingsAccount: "Withdraw Savings Account",
  savingsAccountUpdatedMsg: "Savings Group Account was successfully updated",
  postInterestAasOn: "Post Interest As on",
  viewManagedAccountDetails: "View Managed Account Details",
  detailSavingsAccount: "Savings Account Detail",
  withdrawBalance: "Withdraw Balance",
  isInterestPostingRequiredOnClosureDate:
    "is Interest Posting Required On Closure Date",
  hold: "Hold",
  reasons: "Reasons",
  closeSavingsAccountMsg: "Savings Account Closed Successfully",
  accountTransfers: "Account Transfers",
  transferedFromDetails: "Transfered From Details",
  transferringTo: "Transferring To:",
  fromAccount: "From Account",
  fromAccountType: "From Account Type",
  applicant: "Applicant",
  accountType: "Account Type",
  transactionID: "Transaction Id",
  savingsAccountFundTransferdMsg: "Account Fund was successfully transferred",
  // "Savings Group Account Fund was successfully transferred",
  addCustomerToGroup: "Add Customer to group",
  foreClosureMsg: "Loan Foreclosure Completed Successfully",
  interestRecalculationDate: "Interest Recalculation Date",
  subStatus: "Sub Status",
  reasonForBlock: "Reason for Block/Hold	",
  withdrawFee: "Withdraw Fee",
  balanceOnHold: "Balance On Hold",
  holdAccount: "Hold Account",
  balanceRequiredForInterestCalculation:
    "Balance Required For Interest Calculation",

  writeOffOn: "Write Off On",
  lienTransaction: "Lien Transaction",
  deleteChargeMsg: "Charge was successfully deleted",
};

/*!*******************************************************************************!
    !*** GROUP STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  manageBreadcrumbItems: [{ title: labelConfig.manageGroup }],

  newBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.newGroup },
  ],
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  filterByEntries: [
    { label: "All", value: "All" },
    { label: "Manual Entries", value: "Manual Entries" },
    { label: "System Entries", value: "System Entries" },
  ],
  attachMeetDailyYearlyRepeats: [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
  ],
  attachMeetingWeeklyRepeats: [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
  ],
  attachMeetingMonthlyRepeats: [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
    { label: 8, value: 8 },
    { label: 9, value: 9 },
    { label: 10, value: 10 },
    { label: 11, value: 11 },
  ],
  detailGroupBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.detailGroup },
  ],
  editGroupBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.editGroup },
  ],
  savingApplicationBreadcrumbItems: [
    // { title: <Link to="/view-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.newSavingApplication },
  ],

  transferClientsBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.transferClients },
  ],

  yesOrNo: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],

  newCustomerBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.newCustomer },
  ],

  associateNewMembersBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.associateNewMembers },
  ],

  activateCustomerGroupBreadcrumbItems: [
    // { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.activateCustomerGroup },
  ],

  newLoanApplicationBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.newLoanApplication },
  ],

  journalEntriesSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.journalEntries },
  ],
  rejectSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.rejectSavingsGrp },
  ],
  withdrawByAppSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.withdrawSavingsAccount },
  ],
  approveSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.approveSavingsGrpApp },
  ],
  undoApprovalSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.undoApprovalSavingsGrp },
  ],
  addChargeSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.addChargesSavingsGrp },
  ],
  assignSavingsOfficerBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.assignSavingsGrpOfficer },
  ],
  unassignSavingsOfficerBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.unassignSavingsGrpOfficer },
  ],
  assignGroupOfficerBreadcrumbItems: [
    { title: labelConfig.assignGroupOfficer },
  ],

  DetailLoanBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.detailLoanAccount },
  ],
  closeGroupBreadcrumbItems: [{ title: labelConfig.closeGroup }],
  activateSavingsGrpBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.activateSavingsGrp },
  ],
  approveLoanAccBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.approveLoanAcc },
  ],

  rejectLoanAccBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.rejectLoanAcc },
  ],
  undoApprovalBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.undoApproval },
  ],

  loanDisbursalBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.loanDisbursal },
  ],

  disbursalToSavingsBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.loanDisbursalToSavings },
  ],

  writeOffBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.writeOff },
  ],

  undoDisbursalBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.undoDisbursal },
  ],

  closeBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.closeLoanAccount },
  ],

  closeAsRescheduledBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.closeAsRescheduled },
  ],

  foreClosureBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.foreClosure },
  ],

  loanRepaymentBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.loanRepayment },
  ],

  waiveInterestBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.waiveInterest },
  ],

  addLoanChargeBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.addLoanCharge },
  ],

  withdrawLoanAccountBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.withdrawLoanAccount },
  ],

  rescheduleBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.reschedule },
  ],

  rescheduleRequestBreadcrumbItems: [
    // { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.rescheduleRequest },
  ],

  modifyApplicationBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.modifyLoanApplication },
  ],

  assignLoanOfficerBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.assignLoanOfficer },
  ],

  unassignLoanOfficerBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.unassignLoanOfficer },
  ],

  deleteLoanAccountBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.deleteLoanAccount },
  ],

  createGuarantorBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.createGuarantor },
  ],

  viewGuarantorBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.viewGuarantor },
  ],

  addLoanCollateralBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.addLoanCollateral },
  ],

  loanPrepaymentBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.loanPrepayment },
  ],

  recoverFromGurantorsBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.recoverFromGurantors },
  ],

  changeLoanOfficerBreadcrumbItems: [
    { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.changeLoanOfficer },
  ],

  grpAttendanceBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.attendance },
  ],
  grpAttachMeetingBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.attachMeeting },
  ],
  newGlimLoanApplicationBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.newGLIMLoanApplication },
  ],
  glimLoanAccOverviewBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.glimLoanAccountOverview },
  ],
  detailGLIMLoanAccBreadcrumbItems: [
    // { title: <Link to="/detail-group-savings">{labelConfig.groupSavingsDetail}</Link> },
    { title: labelConfig.detailGlimLoanAccount },
  ],

  gsimApplicationBreadcrumbItems: [
    // { title: <Link to="/view-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.newGsimApplication },
  ],
  withdrawBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.withdraw },
  ],
  depositBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.deposit },
  ],
  closeGsimBreadcrumbItems: [
    // { title: <Link to="/detail-group">{labelConfig.detailGroup}</Link> },
    { title: labelConfig.closeGsimAccount },
  ],
  gsimApplicationDetailBreadcrumbItems: [
    // { title: <Link to="/view-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.applicationDetail },
  ],
  gsimAccountDetailBreadcrumbItems: [
    // {
    //   title: (
    //     <Link to="/detail-group-gsim">{labelConfig.applicationDetail}</Link>
    //   ),
    // },
    { title: labelConfig.accountDetail },
  ],
  postInterestAasOnBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.postInterestAasOn },
  ],
  viewManagedAccountDetailsSavingsAccBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.viewManagedAccountDetails },
  ],
  detailSavingsAccountBreadcrumbItems: [
    // { title: <Link to="/acc0101">{labelConfig.manageCurreAccount}</Link> },
    { title: labelConfig.detailSavingsAccount },
  ],
  holdBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.hold },
  ],
  accountTransferBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.accountTransfers },
  ],
  grpSavingsDetailBreadcrumbItems: [
    // { title: <Link to="/acc0103">{labelConfig.manageLoanAccount}</Link> },
    { title: labelConfig.groupSavingsDetail },
  ],
  gsimAccountHoldBreadcrumbItems: [
    // { title: <Link to="/view-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.holdAccount },
  ],
};
